import { Component, OnInit, Output } from '@angular/core';
import { Authenticated, AuthenticationService, SortedSet, User, UserService } from '../../../domain';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'admin-proxy',
  templateUrl: './spoof-user.component.html',
  styleUrls: ['./spoof-user.component.scss']
})
export class SpoofUserComponent implements OnInit {
  message: string;
  usersControl: FormControl;
  @Output() enableNonANRCollaborator: boolean = false;
  constructor(private userService: UserService,
    private readonly snackbar: MatSnackBar,
    private authSvc: AuthenticationService) {
      this.usersControl = new FormControl(new SortedSet<User>());
    }

  ngOnInit(): void {
  }
  Spoof(){
    this.message = null;
    let usreId = this.usersControl.value.toArray()[0]?.id;
    this.userService.spoofUser(usreId).then(result => {
            const authenticated = Authenticated.fromJson(result);
            this.authSvc.accept(authenticated);
            window.location.reload();
          },
         error => {
            console.error('Spoof user failed:', error);
            this.message = [401, 403, 404].includes(error?.status) ? error?.error : null;
            if (!this.message)
              this.snackbar.open('Unable to proxy user. Please try again.', null, { duration: 5000 });
          });
  }
}
